var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _circle, _path15, _path16, _path17, _rect, _rect2, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle2, _path27, _rect3, _rect4, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _polygon, _polygon2, _path35, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1001.27346,
    height: 688.36187,
    viewBox: "0 0 1001.27346 688.36187",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1043.82378,287.98172c-49.095,0-98.79444-7.35791-148.16211-21.96436-47.94727-14.18652-95.68945-35.20361-141.90015-62.46728-72.77051-42.9336-118.9519-88.18653-125.84887-95.12744-26.06421,41.3208-65.65137,73.92431-117.68018,96.91211-41.93066,18.52636-91.99365,30.88476-148.798,36.73144-96.66541,9.95215-180.51258-2.603-181.34827-2.73144a1.00005,1.00005,0,0,1,.30273-1.97706c.83338.12842,84.46534,12.646,180.88306,2.71485,88.86279-9.15283,207.0791-39.79248,265.6167-133.78272a1.00019,1.00019,0,0,1,1.57007-.16406c.47.48926,47.9143,49.45313,126.37231,95.7334,72.37476,42.69141,186.70069,91.76807,320.3418,83.11133a1.00014,1.00014,0,0,1,.12939,1.99609Q1059.61418,287.98245,1043.82378,287.98172Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#ccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M291.75981,290.83634a2.4492,2.4492,0,0,1-2.22276-1.78113l-12.85282-43.17144a2.50011,2.50011,0,0,1,2.29316-3.21147l.00025,0,26.18273-1.07731a2.50048,2.50048,0,0,1,2.4965,3.21915l-13.33016,44.24873a2.45387,2.45387,0,0,1-2.39771,1.779C291.87226,290.84162,291.81561,290.83993,291.75981,290.83634Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M417.79227,281.3565a2.44922,2.44922,0,0,1-2.48056-1.4L395.67517,239.418a2.5001,2.5001,0,0,1,1.74613-3.5388l.00024,0L423.08915,230.6a2.50048,2.50048,0,0,1,2.98227,2.77515l-6.03131,45.81776a2.45386,2.45386,0,0,1-2.08,2.14181C417.90409,281.3436,417.84791,281.35105,417.79227,281.3565Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M556.67089,233.88284a2.44921,2.44921,0,0,1-2.77846-.62712l-30.46944-33.175a2.5001,2.5001,0,0,1,.65417-3.89155l.00023-.00009L547.1409,183.7484a2.50047,2.50047,0,0,1,3.6546,1.7998l7.4057,45.61578a2.45384,2.45384,0,0,1-1.37582,2.64967C556.77428,233.83831,556.72262,233.86162,556.67089,233.88284Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M999.94277,331.78423a2.44919,2.44919,0,0,1-2.00948-2.01868l-7.94085-44.3386a2.50011,2.50011,0,0,1,2.63815-2.93467l.00024,0,26.13883,1.85952a2.50048,2.50048,0,0,1,2.12056,3.47831l-18.19822,42.479a2.45384,2.45384,0,0,1-2.58172,1.49945C1000.05391,331.80206,999.99781,331.794,999.94277,331.78423Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M860.42741,302.74388a2.44922,2.44922,0,0,1-1.51149-2.41424l2.095-44.99532a2.50011,2.50011,0,0,1,3.22354-2.27617l.00022.0001,25.07469,7.61287a2.50047,2.50047,0,0,1,1.29595,3.86212L863.4354,301.91559a2.45386,2.45386,0,0,1-2.85008.88924C860.53183,302.78592,860.4789,302.76565,860.42741,302.74388Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M776.47783,327.68094H761.49346a4.49992,4.49992,0,0,1-4.38868-5.49414l2.77515-12.24659c-35.60815-5.78906-62.39429-44.686-62.39429-90.75927,0-50.45313,32.07471-91.5,71.5-91.5s71.5,41.04687,71.5,91.5c0,46.07324-26.78613,84.97021-62.39428,90.75927l2.77514,12.24659a4.4999,4.4999,0,0,1-4.38867,5.49414Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#ff6584"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M782.48564,313.68094h-24a3.5,3.5,0,0,1,0-7h24a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M757.46943,309.31783a24.77561,24.77561,0,0,0-21.34933,4.586,24.33145,24.33145,0,0,0-8.86481,19.91534c.73206,16.33869,17.18113,25.12047,28.64713,33.90775,13.54959,10.3841,26.26853,22.365,35.44966,36.87078,9.092,14.365,14.79416,31.38739,13.47308,48.53181-1.1426,14.82825-7.86257,29.52923-19.38681,39.1257a45.88415,45.88415,0,0,1-4.56629,3.32541c-1.61889,1.0406-.11634,3.63846,1.51416,2.59042,12.62689-8.11629,20.97964-21.64621,24.14329-36.18244,3.51973-16.17231.3839-33.008-6.53383-47.85409-7.18642-15.42265-18.49057-28.53449-31.1926-39.69774-6.30057-5.53729-12.99285-10.56334-19.77086-15.4943-5.96-4.33585-12.20723-9.00494-15.91131-15.53334a21.63787,21.63787,0,0,1-.22667-21.0633,21.21317,21.21317,0,0,1,18.361-10.79686,20.877,20.877,0,0,1,5.41671.6617c1.87142.47827,2.66976-2.41436.79752-2.89284Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#3f3d56"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M723.48564,244.68094a6.5077,6.5077,0,0,1-6.49951-6.417,74.25552,74.25552,0,0,1,0-48.166,6.5,6.5,0,0,1,12.99951.083l-.03051.17236c-5.68311,15.48877-5.68238,31.52441.00219,47.66162l.02832.166A6.50737,6.50737,0,0,1,723.48564,244.68094Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M213.70631,482.341a4.4761,4.4761,0,0,1-2.49461-2.99991l-3.0487-12.18136c-34.38988,10.89909-75.84408-11.72878-96.63112-52.8462-22.76312-45.0262-12.65776-96.12918,22.5268-113.91683s82.32845,4.37279,105.09157,49.399c20.787,41.11743,14.43142,87.91569-14.73471,109.14752l8.002,9.67722a4.49989,4.49989,0,0,1-1.4378,6.88322l-13.37259,6.76056A4.47814,4.47814,0,0,1,213.70631,482.341Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M201.22646,470.9362a3.50409,3.50409,0,0,1,1.54442-4.70263l21.41847-10.82817a3.5,3.5,0,0,1,3.15821,6.24705L205.9291,472.48062A3.5041,3.5041,0,0,1,201.22646,470.9362Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M226.286,457.30017a24.77561,24.77561,0,0,1,21.122-5.53955,24.33148,24.33148,0,0,1,16.89655,13.7736c6.71827,14.91153-3.99936,30.17009-10.26745,43.18533-7.40711,15.38037-13.3525,31.811-15.00143,48.89878-1.63293,16.92189.95832,34.686,9.87241,49.39024,7.70982,12.71776,20.33966,22.80557,34.954,26.17037a45.88468,45.88468,0,0,0,5.57546.90753c1.91425.19826,1.7454,3.19461-.18257,2.99493-14.93054-1.54635-28.48918-9.8524-37.8709-21.3977-10.43766-12.84474-15.235-29.28436-15.75948-45.65461-.54488-17.006,3.62764-33.80767,9.92683-49.501,3.12457-7.78433,6.82938-15.28914,10.6536-22.74777,3.36266-6.55844,6.83139-13.54392,7.19159-21.04127a21.63781,21.63781,0,0,0-9.30091-18.89992,21.21314,21.21314,0,0,0-21.25724-1.35153,20.87689,20.87689,0,0,0-4.53553,3.0344c-1.45434,1.27117-3.47189-.95013-2.01691-2.22185Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218.71838,381.41507l-.04963-.16094c-2.20757-16.96615-9.44177-31.27727-21.50171-42.53594l-.105-.14006a6.5,6.5,0,0,1,11.56379-5.93911,74.25557,74.25557,0,0,1,21.73123,42.98509,6.5,6.5,0,0,1-11.63868,5.791Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M868.2234,566.1614,758.88648,509.78982a7.00721,7.00721,0,0,1-3.01416-9.4292l6.76343-13.11816a7.00758,7.00758,0,0,1,9.42944-3.01416l109.33728,56.37158a7.00731,7.00731,0,0,1,3.014,9.4292L877.653,563.14724a6.95171,6.95171,0,0,1-4.09155,3.457,7.03373,7.03373,0,0,1-2.1438.33692A6.95569,6.95569,0,0,1,868.2234,566.1614Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#f59e0b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M834.889,513.428a6.96559,6.96559,0,0,1,5.39414.14084l35.831,19.812a17.46934,17.46934,0,0,1,7.25337,22.95166l-.44888-.21865.44928.21893a17.48361,17.48361,0,0,1-21.47644,8.84216l-38.859-13.582a6.99947,6.99947,0,0,1-3.5732-9.237l11.55364-25.23071a7.03706,7.03706,0,0,1,.74314-1.2945A6.95794,6.95794,0,0,1,834.889,513.428Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 817.96866,
    cy: 348.03705,
    r: 53.51916,
    fill: "#f59e0b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M910.76478,786.70193V663.68826a7.00785,7.00785,0,0,1,7-7h14.75928a7.00786,7.00786,0,0,1,7,7V786.70193a7.00787,7.00787,0,0,1-7,7H917.76478A7.00786,7.00786,0,0,1,910.76478,786.70193Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#f59e0b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M878.76478,786.70193V663.68826a7.00785,7.00785,0,0,1,7-7h14.75928a7.00786,7.00786,0,0,1,7,7V786.70193a7.00787,7.00787,0,0,1-7,7H885.76478A7.00786,7.00786,0,0,1,878.76478,786.70193Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#f59e0b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M918.45638,473.6921l.05566-2c-3.7207-.10352-7.001-.33691-9.46582-2.1377a6.14794,6.14794,0,0,1-2.38134-4.52832,3.51432,3.51432,0,0,1,1.15283-2.89453c1.63623-1.38183,4.269-.93457,6.188-.05469l1.65478.75879-3.17334-23.19043-1.98144.27149,2.69922,19.72656c-2.60743-.7666-5.02344-.43652-6.67823.96094a5.471,5.471,0,0,0-1.86035,4.49219,8.13264,8.13264,0,0,0,3.2002,6.07324C911.03353,473.48409,915.14925,473.59933,918.45638,473.6921Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 790.57162,
    y: 335.79882,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 824.57162,
    y: 335.79882,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M968.54627,684.04373,950.03565,562.43044a7.00713,7.00713,0,0,1,5.86695-7.97314l14.5913-2.22119a7.008,7.008,0,0,1,7.97351,5.86719l18.5105,121.61279a7.00788,7.00788,0,0,1-5.86694,7.97363l-14.59119,2.22071a6.99379,6.99379,0,0,1-7.97351-5.8667Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#f59e0b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M954.24061,605.98611a6.9656,6.9656,0,0,1-3.05518-4.44775l-5.01916-40.63477a17.46934,17.46934,0,0,1,14.31128-19.354l.08679.49169-.08679-.49218a17.48361,17.48361,0,0,1,19.773,12.18408l11.8396,39.4248a6.99948,6.99948,0,0,1-5.37537,8.31836l-27.205,5.47412a7.03708,7.03708,0,0,1-1.48413.15918A6.95794,6.95794,0,0,1,954.24061,605.98611Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M955.67707,693.88829H812.65437a8.50018,8.50018,0,0,1-7.594-12.31885L874.2093,544.05772a47.51643,47.51643,0,0,1,89.96777,21.34668V685.38829A8.50951,8.50951,0,0,1,955.67707,693.88829Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M919.22805,409.70173c-10.95586,2.44614-20.19653,9.58683-31.21246,11.80713-5.01962,1.01171-10.548.97035-15.15826-1.50054a15.79948,15.79948,0,0,1-7.33469-8.55937,23.62064,23.62064,0,0,1,3.76742-22.34144c6.18353-7.56951,16.04269-11.05754,25.50177-12.04062,18.93043-1.96743,38.37475,4.27063,53.78292,15.13717,15.90921,11.2199,28.11373,28.06738,32.20772,47.24127,2.18846,10.24952,1.97258,21.15269-1.764,31.0226a39.52833,39.52833,0,0,1-19.76885,21.54486,38.7961,38.7961,0,0,1-6.76575,2.51921,1.50127,1.50127,0,0,0,.79751,2.89283,42.73055,42.73055,0,0,0,24.76719-18.23872c5.86111-9.375,7.82733-20.85222,6.92456-31.75949-1.74634-21.09933-13.34881-40.492-29.56871-53.768-15.58247-12.75428-35.73976-20.5145-56.00725-19.89794-10.16441.30922-20.71524,2.88942-28.61929,9.5874a26.91885,26.91885,0,0,0-9.34161,23.78683,21.57077,21.57077,0,0,0,4.73556,11.2939,19.518,19.518,0,0,0,12.52842,6.47021c11.984,1.56007,22.37578-5.233,32.96558-9.59955a51.26365,51.26365,0,0,1,8.35973-2.70489c1.88344-.42052,1.08637-3.31346-.79752-2.89284Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M949.32954,388.49986c-4.30292-16.10736,6.92622-32.87153,22.18366-37.90167a43.58532,43.58532,0,0,1,26.84.29943,52.9419,52.9419,0,0,1,22.11841,14.44056c13.37426,14.22833,19.299,33.43205,22.07122,52.36571,2.86235,19.54929,1.247,40.9606,11.25027,58.72519,4.14738,7.36522,10.30331,13.81434,18.2572,16.98577,7.42015,2.95861,16.30971,2.9725,23.41867-.87294a22.45791,22.45791,0,0,0,4.70548-3.437c1.40714-1.32778-.717-3.44639-2.12132-2.12132-5.95278,5.61708-14.8253,6.67662-22.47647,4.47236-8.34538-2.40426-14.76864-8.81808-19.00146-16.2035-4.89491-8.54061-6.93322-18.30285-8.04481-27.98892-1.21346-10.57366-1.681-21.20427-3.30151-31.73482-2.92281-18.99328-9.23825-38.05862-22.636-52.31188a56.3627,56.3627,0,0,0-22.27491-14.82068,47.22383,47.22383,0,0,0-27.27767-1.37732,37.20289,37.20289,0,0,0-20.50635,13.79,34.67929,34.67929,0,0,0-7.07262,22.53589,30.61611,30.61611,0,0,0,.97529,5.95259,1.50128,1.50128,0,0,0,2.89284-.79752Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M506.90613,573.08515l-124.36306-8.14393a14.95972,14.95972,0,1,1,1.95507-29.85549l124.36333,8.14446a7.00582,7.00582,0,0,1,6.53278,7.44874l-1.03964,15.87371a7.00586,7.00586,0,0,1-6.9801,6.54778Q507.14125,573.10042,506.90613,573.08515Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#f59e0b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M482.5872,575.1418l-102.26733-3.82226a7.00514,7.00514,0,0,1-6.73934-7.26192l.88623-23.70925a7.006,7.006,0,0,1,7.26244-6.73934l102.26734,3.82225a7.00514,7.00514,0,0,1,6.73934,7.26192l-.88623,23.70926a7.01469,7.01469,0,0,1-6.99774,6.7446C482.76429,575.14706,482.67562,575.14548,482.5872,575.1418Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M356.00541,786.6963V654.113a7.01357,7.01357,0,0,1,7.00563-7.00562H378.919a7.01357,7.01357,0,0,1,7.00563,7.00562V786.6963a7.01357,7.01357,0,0,1-7.00563,7.00563H363.011A7.01357,7.01357,0,0,1,356.00541,786.6963Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M423.99745,721.25989,355.273,607.87874a7.01355,7.01355,0,0,1,2.35964-9.62235l13.60373-8.24572a7.01358,7.01358,0,0,1,9.62236,2.35963l68.72444,113.38115a7.01358,7.01358,0,0,1-2.35964,9.62236l-13.60373,8.24572A7.01358,7.01358,0,0,1,423.99745,721.25989Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.8085,
    cy: 347.95596,
    r: 54.96724,
    fill: "#f59e0b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M416.92518,472.54275a13.03633,13.03633,0,0,0,4.76048-2.79439,8.76617,8.76617,0,0,0,2.56244-6.93989,5.89718,5.89718,0,0,0-2.62177-4.53865c-1.96568-1.26092-4.59469-1.26465-7.27145-.085l.10132-21.45843-2.15543-.01027-.11924,25.22665,1.66087-1.04474c1.92594-1.20943,4.6764-2.06074,6.61987-.81377a3.787,3.787,0,0,1,1.6399,2.93042,6.62432,6.62432,0,0,1-1.90529,5.17441c-2.3802,2.27364-5.85285,2.98465-9.81293,3.62l.34163,2.12811A35.52627,35.52627,0,0,0,416.92518,472.54275Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 425.25808,
    y: 436.39294,
    width: 11.60959,
    height: 2.15531,
    transform: "translate(-152.92962 -45.61527) rotate(-7.5232)",
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 388.92856,
    y: 441.18957,
    width: 11.60959,
    height: 2.15531,
    transform: "translate(-153.87036 -50.33052) rotate(-7.5232)",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M332.11276,680.52409V572.18472A49.61275,49.61275,0,0,1,381.66947,522.628h32.89414a9.15026,9.15026,0,0,1,9.15674,9.09174L443.125,680.52409a9.17144,9.17144,0,0,1-9.1612,9.1612H341.274A9.17144,9.17144,0,0,1,332.11276,680.52409Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#2f2e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M263.29169,628.72087l94.30783-81.47723a14.95911,14.95911,0,1,1,19.55931,22.63919l-94.30747,81.4777a7.00505,7.00505,0,0,1-9.881-.72093L262.5703,638.60224a7.00622,7.00622,0,0,1,.72139-9.88137Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#f59e0b"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M284.10651,601.83257l77.44035-66.90478a7.00505,7.00505,0,0,1,9.881.72092l17.76321,20.56043a7.00505,7.00505,0,0,1-.72128,9.88113l-77.43987,66.905a7.01359,7.01359,0,0,1-9.881-.72093L283.38524,611.7137a7.00593,7.00593,0,0,1,.72127-9.88113Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#2f2e41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M386.14381,421.174c7.348-6.08071,17.17054-.32962,25.48021-1.14588,7.95-.78092,14.34878-7.77725,16.09249-15.306,2.03433-8.78355-2.3753-17.70594-9.01776-23.33263-7.27513-6.16262-17.04268-8.07765-26.35085-7.13991-10.66839,1.07478-20.49716,5.8514-29.34595,11.68677a131.32953,131.32953,0,0,0-23.47738,19.14c-6.3274,6.72677-11.73316,14.78552-13.58484,23.96393-1.6828,8.34128-.69551,17.63875,4.11789,24.8235a26.08821,26.08821,0,0,0,10.04952,8.6049c4.20336,2.16408,8.70108,3.73952,12.767,6.17329,6.14763,3.67988,12.048,11.18,9.9551,18.82849a10.55463,10.55463,0,0,1-2.48446,4.46954c-1.42013,1.5175-3.89007-.57037-2.46619-2.09187,2.50083-2.6723,2.47326-6.30009,1.22969-9.57094a17.538,17.538,0,0,0-7.63188-8.71957c-4.2561-2.54183-8.97778-4.15059-13.34526-6.47519a29.12455,29.12455,0,0,1-10.51234-9.05412c-5.13893-7.43549-6.53642-17.01171-5.17156-25.82006,1.477-9.53194,6.55209-18.12276,12.84552-25.28309,6.849-7.79244,15.20457-14.33994,23.72483-20.20272,9.14231-6.29082,19.21092-11.56482,30.27521-13.33132,9.591-1.53127,19.93156-.27987,28.191,5.08786,7.70969,5.01043,13.53366,13.488,13.95111,22.84526a23.965,23.965,0,0,1-11.58969,21.277,20.58688,20.58688,0,0,1-12.34952,2.61484c-4.58669-.38121-9.15664-1.87478-13.78565-1.57218a9.63627,9.63627,0,0,0-5.72043,2.18581c-1.60543,1.32855-3.43805-1.3381-1.8458-2.65574Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#2f2e41"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M449.74829,712.57789l-41.23744,63.93418a7.014,7.014,0,0,1-9.68459,2.08981l-13.36839-8.62234a7.00668,7.00668,0,0,1-2.08981-9.68459l41.23743-63.93418a7.014,7.014,0,0,1,9.6846-2.08981l13.36787,8.62242a6.95786,6.95786,0,0,1,3.05073,4.40937q.0399.18186.06921.3641A6.9553,6.9553,0,0,1,449.74829,712.57789Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#2f2e41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.23761,794.18094h-893a1,1,0,0,1,0-2h893a1,1,0,0,1,0,2Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 398.12237,
    y: 295.36187,
    width: 6,
    height: 19,
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.12237,
    y: 241.36187,
    width: 6,
    height: 19,
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.48566,
    y: 405.18089,
    width: 6,
    height: 19,
    transform: "translate(-231.52057 345.30596) rotate(-38.5192)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.98564,
    y: 469.68092,
    width: 19,
    height: 6,
    transform: "translate(-235.97413 602.92581) rotate(-60)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.98566,
    y: 284.68093,
    width: 18.99998,
    height: 6,
    transform: "translate(-89.25945 487.04314) rotate(-60)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.12237,
    y: 496.36187,
    width: 6,
    height: 19,
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 667.12237,
    y: 442.36187,
    width: 6,
    height: 19,
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.48566,
    y: 606.18089,
    width: 6,
    height: 19,
    transform: "translate(-319.27143 496.16127) rotate(-38.5192)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 707.98564,
    y: 670.68092,
    width: 19,
    height: 6,
    transform: "translate(-324.04524 852.38218) rotate(-60)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680.98566,
    y: 485.68093,
    width: 18.99998,
    height: 6,
    transform: "translate(-177.33055 736.49951) rotate(-60)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M392.04505,398.83344l-9.74748-5.79233-7.73809-4.60535L363.337,381.76437l-7.74792-4.59984-10.53221-6.27a1.1351,1.1351,0,0,0-1.711.95914l-.10832,8.91332-.093,6.88873-.12828,9.98425-.07767,6.893-.12829,9.98424-.08324,6.88326-.06586,5.11585a1.04925,1.04925,0,0,0,.13794.56886,1.18054,1.18054,0,0,0,.40345.42,1.12415,1.12415,0,0,0,1.13114.0121l47.69256-26.73483a1.06382,1.06382,0,0,0,.55757-.80365.84477.84477,0,0,0,.02231-.16759,1.18067,1.18067,0,0,0-.14779-.56334A1.0492,1.0492,0,0,0,392.04505,398.83344Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#ccc"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "263.973 275.945 243.782 281.837 243.874 274.948 256.226 271.345 263.973 275.945",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "282.934 287.222 243.575 298.714 243.653 291.821 275.196 282.616 282.934 287.222",
    fill: "#3f3d56"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M392.58382,399.97892a1.0638,1.0638,0,0,1-.55757.80364l-23.18744,12.99809L342.727,421.40051l.08324-6.88326Z",
    transform: "translate(-99.36327 -105.81906)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.35749,
    cy: 261.13002,
    r: 9.01852,
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaves);
export default __webpack_public_path__ + "static/media/leaves.6d628dddca29a7e42bffafa9e429f020.svg";
export { ForwardRef as ReactComponent };